import moment from 'moment';

export default {
  data() {
    return {
      xmlErrorsModal: {
        show: false,
        batch: null,
        errors: [],
        warnings: [],
      },
    };
  },
  methods: {
    async validateXml(batch) {
      const { data } = await this.$http.get(`/billing-batches/${batch.id}/xml-validate`);
      return data;
    },
    async downloadXml(batch) {
      const frozen = batch.status !== 'closed' && !!(batch.file && batch.file.generatedAt);
      if (!frozen) {
        const validation = await this.validateXml(batch);
        if (validation.errors && validation.errors.length > 0) {
          this.openXmlErrors(batch, validation);
          return false;
        }
      }

      const name = (batch.file && batch.file.name)
        || `TISS_LOTE_${batch.number}_${moment().format('YYYYMMDD')}.xml`;

      await this.$file.download(`/billing-batches/${batch.id}/xml`, {}, { name });
      this.$toast.success(frozen ? 'XML do lote baixado.' : 'XML gerado e congelado no lote.');
      return true;
    },
    openXmlErrors(batch, validation) {
      this.xmlErrorsModal.batch = batch;
      this.xmlErrorsModal.errors = validation.errors || [];
      this.xmlErrorsModal.warnings = validation.warnings || [];
      this.xmlErrorsModal.show = true;
    },
    closeXmlErrors() {
      this.xmlErrorsModal.show = false;
      this.xmlErrorsModal.batch = null;
      this.xmlErrorsModal.errors = [];
      this.xmlErrorsModal.warnings = [];
    },
  },
};
